/*
  AJD · buscador de la cabecera (21/10/2026, rutina de mejora, punto de vista «clienta con prisa en el móvil»).

  1. Sugerencias mientras se escribe: hasta 6 productos (foto, nombre, precio, «Agotada») y las colecciones que
     casen, con la API de Shopify /search/suggest.json. Antes la caja de arriba no sugería nada.
  2. Atajos por lo que pide la búsqueda, porque el buscador de Shopify no entiende tallas, edades ni precios:
       «ropita 42 cm»               → Ropita para muñecas de 42 cm
       «muñeca para niña de 3 años» → las líneas de esa edad (edad ideal de las fichas) y la guía por edades
       «regalo 50 €»                → muñecas disponibles de hasta 50 €
     Salen arriba de las sugerencias y arriba de la página de resultados (sections/main-search.liquid).

  La edad de cada línea sale de custom.edad_ideal de las fichas en stock (21/10/2026). Si cambian las colecciones o
  las edades, cambiar EDADES.
  En la página de resultados este fichero se carga también sin «defer» (para pintar los atajos sin salto); por eso
  la guarda de la primera línea.
*/
(function () {
  if (window.ajdBusca) return;

  var GUIA = { t: 'Guía: qué muñeca regalar según la edad', u: '/blogs/blog/que-muneca-antonio-juan-regalar-segun-edad' };
  var TALLAS_GUIA = { t: 'Guía de tallas: qué ropita le vale a su muñeca', u: '/pages/guia-tallas-medidas-munecas-reborn-antonio-juan' };
  var ROPA_TALLA = { 26: 'ropa-munecas-26cm', 33: 'ropa-munecas-33cm', 42: 'ropa-munecas-42cm-talla', 52: 'ropa-munecas-52cm-talla' };
  var TAMANOS = [21, 26, 27, 33, 34, 36, 37, 38, 42, 45, 50, 52];
  var L = {
    ariel: { t: 'Ariel, la Organic Doll (desde 10 meses)', u: col('munecas-organicas-26cm-desde-10-meses') },
    primeras: { t: 'Primeras muñecas (de 18 meses a 4 años)', u: col('primera-infancia-munecas-antonio-juan') },
    toneta: { t: 'Toneta (de 2 a 6 años)', u: col('toneta') },
    recien: { t: 'Recién Nacidos de 42 cm (de 3 a 8 años)', u: col('munecas-recien-nacidos-antonio-juan') },
    fashion: { t: 'Iris, Emily y Bella (de 6 a 12 años)', u: col('coleccion-fashion-munecas-estilo-antonio-juan') },
    reborn: { t: 'Mi Primer Reborn (de 6 a 14 años)', u: col('mi-primer-reborn') },
    realistas: { t: 'Reborn realistas y de silicona', u: col('reborn-munecas-realistas') }
  };
  // edad en meses → líneas, de la que mejor le va a la siguiente
  var EDADES = [
    [18, ['ariel', 'primeras']],
    [24, ['primeras', 'ariel']],
    [36, ['primeras', 'toneta']],
    [48, ['toneta', 'recien', 'primeras']],
    [72, ['recien', 'toneta']],
    [108, ['recien', 'fashion', 'reborn']],
    [156, ['fashion', 'reborn']],
    [180, ['reborn', 'realistas']],
    [9999, ['realistas']]
  ];

  var ROPA = /\b(ropa|ropita|vestid|conjunt|pelele|ranita|abrig|chaquet|gorr|zapat|jersey|pijama)/;
  // tipos de muñeca: la misma lista que ajd-entrega, ajd-partida-cesta, ajd-exclusiva y main-product
  var TIPOS_MUNECA = ['Muñecas', 'Mufly', 'Picolín', 'Pitu'];
  function pideRopa(s) { return ROPA.test(norm(s)); }
  function num(t) { return +String(t).replace(',', '.'); }
  function eur(n) { return (n % 1 ? n.toFixed(2).replace('.', ',') : String(n)) + ' €'; }
  function norm(s) { return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/\s+/g, ' ').trim(); }
  function enlace(t, u) { return { t: t, u: u }; }
  // a una colección se llega con «solo disponibles» puesto: con prisa no sirve ver lo agotado
  function col(h) { return '/collections/' + h + '?filter.v.availability=1'; }
  function disponibles(col, desde, hasta) {
    return '/collections/' + col + '?filter.v.availability=1' + (desde ? '&filter.v.price.gte=' + desde : '') +
      '&filter.v.price.lte=' + hasta + '&sort_by=price-descending';
  }

  // Lo que pide la búsqueda, en atajos {t, u}. Como mucho 3, y la guía si viene a cuento.
  function atajosDe(q) {
    var s = norm(q), out = [], m;
    if (s.length < 2) return out;
    var ropa = pideRopa(s);

    // 23/10/2026: carritos, sillitas y tronas (La Nina, DeCuevas) y capazos y cunas. Muchas fichas se llaman «cuco con ruedas»
    // o «gemelar» y el buscador de Shopify no las saca con «carrito». Si se pide uno de estos, solo estos atajos.
    var acc = [];
    if (!ropa && /\b(carrit|carro|cochecit|ruedas|silla|sillit|trona|gemelar|portabeb|maxi ?cosi)/.test(s)) acc.push(enlace('Carritos, sillitas y tronas', col('acc-carritos-sillitas-tronas')));
    if (!ropa && /\b(capazo|cuna|cunita|moises|cuco)/.test(s)) acc.push(enlace('Capazos y cunas', col('acc-capazos-cunas')));
    if (acc.length) return acc;

    // precio: «50 €», «50 euros», «menos de 40», «hasta 60», «entre 30 y 50»
    var desde = 0, hasta = 0;
    // con céntimos si los trae («30,50 €»): el filtro de Shopify admite decimales
    if ((m = s.match(/entre (\d{1,3}(?:[.,]\d{1,2})?) y (\d{1,3}(?:[.,]\d{1,2})?)( ?(€|eur|euros))?/))) { desde = num(m[1]); hasta = num(m[2]); s = s.replace(m[0], ' '); }
    else if ((m = s.match(/(menos de|hasta|por|maximo|max\.?) (\d{1,3}(?:[.,]\d{1,2})?)( ?(€|eur|euros))?/))) { hasta = num(m[2]); s = s.replace(m[0], ' '); }
    else if ((m = s.match(/(\d{1,3}(?:[.,]\d{1,2})?) ?(€|eur\b|euros\b)/))) { hasta = num(m[1]); s = s.replace(m[0], ' '); }

    // edad: «3 años», «18 meses», «un año»
    var meses = 0;
    if ((m = s.match(/\b(\d{1,2}|un|una) ?(anos?|anitos?|mes|meses)\b/))) {
      var n = /^\d/.test(m[1]) ? +m[1] : 1;
      meses = /^mes/.test(m[2]) ? n : n * 12;
      s = s.replace(m[0], ' ');
    }

    // tamaño: «42 cm», «42cm» o un número de tamaño suelto («muñeca 42»)
    var cm = 0;
    if ((m = s.match(/\b(\d{2}) ?(cm|centimetros)\b/)) || (m = s.match(/\b(\d{2})\b/))) {
      if (TAMANOS.indexOf(+m[1]) >= 0) cm = +m[1];
    }

    if (ropa) {
      if (cm && ROPA_TALLA[cm]) out.push(enlace('Ropita para muñecas de ' + cm + ' cm', col(ROPA_TALLA[cm])));
      if (hasta) out.push(enlace('Ropita ' + (desde ? 'de ' + eur(desde).replace(' €', '') + ' a ' : 'de hasta ') + eur(hasta) + ', disponible', disponibles('ropita-munecas', desde, hasta)));
      if (!cm || !ROPA_TALLA[cm]) out.push(enlace('Ropita para muñecas que tenemos ya', col('ropita-munecas')));
      out.push(TALLAS_GUIA);
    } else {
      if (meses) {
        var lineas = EDADES.filter(function (e) { return meses < e[0]; })[0][1];
        lineas.slice(0, 2).forEach(function (k) { out.push(L[k]); });
      }
      if (hasta) out.push(enlace('Muñecas ' + (desde ? 'de ' + eur(desde).replace(' €', '') + ' a ' : 'de hasta ') + eur(hasta) + ', disponibles', disponibles('munecas-antonio-juan', desde, hasta)));
      if (cm) {
        out.push(enlace('Muñecas de ' + cm + ' cm', col('munecas-' + cm + 'cm')));
        if (ROPA_TALLA[cm] && !meses && !hasta) out.push(enlace('Ropita para muñecas de ' + cm + ' cm', col(ROPA_TALLA[cm])));
      }
      if (meses || /\bregal/.test(s)) out.push(GUIA);
    }
    return out.slice(0, 3);
  }

  function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function precio(p) { var n = parseFloat(p); return isNaN(n) ? '' : n.toFixed(2).replace('.', ',') + ' €'; }
  function img(u, w) { return u ? u + (u.indexOf('?') < 0 ? '?' : '&') + 'width=' + w : ''; }
  function htmlAtajos(lista, clase) {
    return lista.map(function (a) {
      return '<a class="' + clase + '" href="' + esc(a.u) + '"><span aria-hidden="true">✦</span>' + esc(a.t) + '<span class="ajd-sug__flecha" aria-hidden="true">›</span></a>';
    }).join('');
  }

  // ---------- atajos en la página de resultados ----------
  function pintaAtajos(el, q) {
    if (!el) return;
    var a = atajosDe(q);
    if (!a.length) { el.hidden = true; return; }
    el.innerHTML = '<p class="ajd-atajos-busq__tit">Para ir más rápido:</p>' + htmlAtajos(a, 'ajd-atajos-busq__a');
    el.hidden = false;
  }

  // ---------- sugerencias al escribir ----------
  function iniciaSugerencias() {
    var form = document.querySelector('form.ajd-busca'), inp = form && form.querySelector('input[name="q"]');
    if (!inp || inp.dataset.ajdSug) return;
    inp.dataset.ajdSug = '1';
    var panel = document.createElement('div');
    panel.id = 'ajd-sug'; panel.className = 'ajd-sug'; panel.hidden = true;
    panel.setAttribute('role', 'region'); panel.setAttribute('aria-label', 'Sugerencias de búsqueda');
    var vivo = document.createElement('p');
    vivo.className = 'visually-hidden'; vivo.setAttribute('aria-live', 'polite');
    document.body.appendChild(panel); document.body.appendChild(vivo);
    inp.setAttribute('aria-controls', 'ajd-sug');   // sin aria-expanded: un input de búsqueda no lo admite (axe)

    var temp = null, ctrl = null, ultima = '', aMano = false;   // aMano: cerrado con Escape, no se reabre al volver el foco
    function coloca() {
      var r = form.getBoundingClientRect(), vv = window.visualViewport, alto = vv ? vv.height : window.innerHeight;
      panel.style.top = (r.bottom + 6) + 'px';
      panel.style.left = Math.max(8, r.left) + 'px';
      panel.style.width = Math.min(r.width, window.innerWidth - 16) + 'px';
      panel.style.maxHeight = Math.max(200, alto - r.bottom - 16) + 'px';
    }
    function cierra() {
      clearTimeout(temp); if (ctrl) { ctrl.abort(); ctrl = null; } ultima = '';   // lo pendiente ya no lo reabre (QA Codex 21/10)
      if (panel.hidden) return;
      panel.hidden = true;
    }
    function abre() { coloca(); panel.hidden = false; }

    function pinta(q, res) {
      var a = atajosDe(q), p = (res && res.products) || [], c = (res && res.collections) || [], h = '';
      // «ropita 42» casa con muñecas de 42 cm: si se pide ropa, las muñecas sobran
      if (pideRopa(q)) p = p.filter(function (x) { return TIPOS_MUNECA.indexOf(x.type) < 0; });
      if (a.length) h += '<div class="ajd-sug__grupo">' + htmlAtajos(a, 'ajd-sug__atajo') + '</div>';
      if (p.length) {
        h += '<div class="ajd-sug__grupo"><p class="ajd-sug__tit">Productos</p>' + p.map(function (x) {
          var foto = x.featured_image && x.featured_image.url ? x.featured_image.url : x.image;
          var rebaja = parseFloat(x.compare_at_price_max) > parseFloat(x.price);
          return '<a class="ajd-sug__prod" href="' + esc(x.url) + '">' +
            (foto ? '<img src="' + esc(img(foto, 120)) + '" alt="" width="56" height="56" loading="lazy">' : '<span class="ajd-sug__sinfoto"></span>') +
            '<span class="ajd-sug__txt"><span class="ajd-sug__nom">' + esc(x.title) + '</span>' +
            '<span class="ajd-sug__precio">' + (rebaja ? '<s>' + precio(x.compare_at_price_max) + '</s> ' : '') + precio(x.price) +
            (x.available ? '' : ' <em>Agotada</em>') + '</span></span></a>';
        }).join('') + '</div>';
      }
      if (c.length) {
        h += '<div class="ajd-sug__grupo"><p class="ajd-sug__tit">Colecciones</p><div class="ajd-sug__cols">' + c.map(function (x) {
          return '<a class="ajd-sug__col" href="' + esc(x.url) + '">' + esc(x.title) + '</a>';
        }).join('') + '</div></div>';
      }
      if (!a.length && !p.length && !c.length) {
        h = '<p class="ajd-sug__nada">No vemos nada con «' + esc(q) + '». Pruebe con el nombre (Lúa, Nica, Pipa…), el tamaño (42 cm) o la referencia de la caja.</p>';
      } else {
        h += '<a class="ajd-sug__todo" href="/search?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last">Ver todos los resultados de «' + esc(q) + '»</a>';
      }
      panel.innerHTML = h;
      vivo.textContent = p.length ? p.length + ' sugerencias' : '';
      abre();
    }

    function busca() {
      var q = inp.value.trim();
      if (q.length < 2) { ultima = ''; cierra(); return; }
      if (q === ultima && !panel.hidden) return;
      ultima = q;
      if (ctrl) ctrl.abort();
      ctrl = window.AbortController ? new AbortController() : null;
      var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection&resources[limit]=6&resources[limit_scope]=each' +
        '&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.sku,variants.barcode,vendor';
      fetch(url, ctrl ? { signal: ctrl.signal } : {})
        .then(function (r) { return r.json(); })
        .then(function (d) { if (q === inp.value.trim()) pinta(q, d.resources && d.resources.results); })
        .catch(function (e) { if (!e || e.name !== 'AbortError') pinta(q, null); });
    }

    inp.addEventListener('input', function () { aMano = false; clearTimeout(temp); temp = setTimeout(busca, 180); });
    inp.addEventListener('focus', function () { if (!aMano && inp.value.trim().length >= 2 && panel.innerHTML) abre(); });
    inp.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { aMano = true; cierra(); }
      else if (e.key === 'ArrowDown' && !panel.hidden) { var f = panel.querySelector('a'); if (f) { e.preventDefault(); f.focus(); } }
    });
    panel.addEventListener('keydown', function (e) {
      var as = [].slice.call(panel.querySelectorAll('a')), i = as.indexOf(document.activeElement);
      if (e.key === 'ArrowDown' && i < as.length - 1) { e.preventDefault(); as[i + 1].focus(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); (i > 0 ? as[i - 1] : inp).focus(); }
      else if (e.key === 'Escape') { aMano = true; cierra(); inp.focus(); }
    });
    document.addEventListener('pointerdown', function (e) { if (!panel.contains(e.target) && !form.contains(e.target)) cierra(); });
    document.addEventListener('focusin', function (e) { if (!panel.contains(e.target) && !form.contains(e.target)) cierra(); });
    form.addEventListener('submit', cierra);
    window.addEventListener('resize', function () { if (!panel.hidden) coloca(); });
    window.addEventListener('scroll', function () { if (!panel.hidden) coloca(); }, { passive: true });
    if (window.visualViewport) window.visualViewport.addEventListener('resize', function () { if (!panel.hidden) coloca(); });
  }

  window.ajdBusca = { atajosDe: atajosDe, pintaAtajos: pintaAtajos };
  if (document.querySelector('form.ajd-busca')) iniciaSugerencias();
  else document.addEventListener('DOMContentLoaded', iniciaSugerencias);
})();
